import { useEffect, useRef, useState } from "react";
import { supplierMasterExcelExportHeader, supplierMasterHeader } from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import SupplierPopup from "../popup-containers/SupplierPopup";
import MainPopup from "../popup-containers/MainPopup";
import toast from "react-hot-toast";
import Loader from "../ReusableComponents/Loader";
import { BindAPI, IUDAPI } from "../services/APIConnection";
import GridPage from "../components/GridPage";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import FileUpload from "../ReusableComponents/FileUpload";
import { useLocation } from "react-router-dom";
import ErrorPopup from "../ReusableComponents/ErrorPopup";

import * as XLSX from "sheetjs-style";
const SupplierMaster = () => {
  const location = useLocation();
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const supplierNameRef = useRef(null);
  const addressRef = useRef(null);
  const countryRef = useRef(null);
  const stateRef = useRef(null);
  const branchProjectRef = useRef(null);
  const pinCodeRef = useRef(null);
  const contactPersonRef = useRef(null);
  const contactNumberRef = useRef(null);
  const contactPersonDesignationRef = useRef(null);
  const [supplierFields, setSupplierFields] = useState({
    supplierId: "SUP",
    supplierName: "",
    address: "",
    country: "1",
    state: "",
    branchProject: "",
    pinCode: "",
    date: new Date(),
    commodities: null,
    showImage: "",
    contactPerson: "",
    contactPersonDesignation: "",
    contactNumber: "",
    contactPersonEmail: "",
  });

  const [supplierFieldsError, setSupplierFieldsError] = useState({
    supplierIdError: "",
    supplierNameError: "",
    addressError: "",
    countryError: "",
    stateError: "",
    branchProjectError: "",
    pinCodeError: "",
    dateError: "",
    branchProjectError: "",
    showImageError: "",
  });
  useEffect(() => {
    const fetchData = async () => {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      setSupplierFields({ ...supplierFields, date: formattedDate });
    };

    fetchData();
  }, []);
  const handleSupplierFieldsChange = (value, name) => {
    setSupplierFields({
      ...supplierFields,
      [name]: value,
    });
  };

  const [mstSupplierId, setMstSupplierId] = useState("");

  const [supplierData, setSupplierData] = useState({});

  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);

  // View details start

  const [rowIndex, setRowIndex] = useState("");
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [submitVisibleButton, setSubmitVisibleButton] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [getLocationDatas, setGetLocationDatas] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [supplierdata2, setSupplierdata2] = useState({});

  // view details end

  const [bindSupplierMasterDatas, setBindSupplierMasterDatas] = useState([]);
  const [bindCommoditiesDD, setBindCommoditiesDD] = useState([]);

  useEffect(() => {
    BindSupplierGridData();
    fetchDropdownData();
    getSelectedLocation();
  }, []);

  // ✅ Supplier Grid
  const BindSupplierGridData = async () => {
    setIsLoading(true);
    try {
      const response = await BindAPI("SupplierAPI/BindSupplier");
      setBindSupplierMasterDatas(response?.data?.Table ?? []);
    } catch (error) {
      console.error("Error fetching supplier data:", error);
      setBindSupplierMasterDatas([]);
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ Fetch all dropdowns in one call (Country, State, Medicines/Drugs)
  const fetchDropdownData = async () => {
    try {
      const response = await BindAPI("MasterDataAPI/BindAllMasterData");

      // Country
      const countryDD =
        response?.data?.Table9?.map((m) => ({
          value: m.MstCountryId,
          label: m.CountryName_en,
        })) ?? [];
      setCountryBindDD(countryDD);

      // State
      const stateDD =
        response?.data?.Table?.map((m) => ({
          value: m.MstStateId,
          label: m.StateName_en,
        })) ?? [];
      setStateBindDD(stateDD);

      // Medicines/Drugs
      const medicinesdrugsDD =
        response?.data?.Table10?.map((m) => ({
          value: m.MstCommoditiesId,
          label: m.CommodityName_en,
        })) ?? [];
      setBindCommoditiesDD(medicinesdrugsDD);
    } catch (error) {
      console.error("❌ Error fetching master dropdown data:", error);
      setCountryBindDD([]);
      setStateBindDD([]);
      setBindCommoditiesDD([]);
    }
  };

  // ✅ Location
  const getSelectedLocation = async () => {
    try {
      const locationResponse = await BindAPI("LocationAPI/GetLocation");
      setGetLocationDatas(locationResponse?.data?.Table ?? []);
    } catch (error) {
      console.error("Error fetching location:", error);
      setGetLocationDatas([]);
    }
  };

  useEffect(() => {
    // Find the selected state in getLocationDatas
    const stateSelectedValue = getLocationDatas.find(
      (item) => item.MstStateId == supplierFields.state // Replace with the desired MstStateId
    );
    if (stateSelectedValue) {
      const branchProjectLabels = getLocationDatas
        .filter((item) => item.MstStateId === stateSelectedValue.MstStateId)
        .map((item) => ({
          MstLocationId: item.MstLocationId,
          LocationName_en: item.LocationName_en,
        }));
      const branchProjectSelected = branchProjectLabels.map((LC) => ({
        value: LC.MstLocationId, // Replace with the appropriate value
        label: LC.LocationName_en,
      }));
      setBranchProjectBindDD(branchProjectSelected);
    } else {
    }
  }, [supplierFields.state]);

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true); // Add Screen title & button
    setUpdateScreenTitle(false); // Update Screen title & button
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
    setSupplierFields({ ...supplierFields, date: formattedDate });
  };

  const cancel = () => {
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setSubmitBtnDisabled(false);
    setSubmitVisibleButton(false);
    clear();
  };
  const clear = () => {
    //Clear Supplier data
    BindSupplierGridData();
    setIsLoading(false);
    setSupplierFields({
      supplierId: "SUP",
      supplierName: "",
      address: "",
      country: "1",
      state: "",
      branchProject: "",
      pinCode: "",
      date: "",
      commodities: null,
      imageUploaded: "",
      contactPerson: "",
      contactPersonDesignation: "",
      contactNumber: "",
      contactPersonEmail: "",
    });
    setSupplierFieldsError({
      supplierIdError: "",
      supplierNameError: "",
      addressError: "",
      countryError: "",
      stateError: "",
      branchProjectError: "",
      pinCodeError: "",
      dateError: "",
      branchProjectError: "",
      sdpError: "",
      userIdError: "",
      showImageError: "",
    });
  };

  const handleShowImage = (showImage) => {
    // Set showImage to an empty string if showImage is falsy
    setSupplierFields({
      ...supplierFields,
      showImage: showImage || "", // This will set to showImage if it's truthy, else ""
    });

    console.log(supplierFields);

    // Reset any error related to showImage
    setSupplierFieldsError({ ...supplierFieldsError, showImageError: "" });
  };

  const handleEdit = async (rowIndex) => {
    setEditMode(true);
    setSelectedRowIndex(rowIndex);
    setVisibleAdd(true);
    setVisibleTable(false);
    setUpdateScreenTitle(true);
    setAddScreenTitle(false);
    var supplierDate = bindSupplierMasterDatas[rowIndex].SupplierDate;
    const supplierDatePart = supplierDate.split("T")[0];
    setSupplierFields({
      ...supplierFields,
      supplierId: bindSupplierMasterDatas[rowIndex].SupplierId,
      supplierName: bindSupplierMasterDatas[rowIndex].SupplierName,
      address: bindSupplierMasterDatas[rowIndex].SupplierAddress,
      country: bindSupplierMasterDatas[rowIndex].MstCountryId,
      state: bindSupplierMasterDatas[rowIndex].MstStateId,
      branchProject: bindSupplierMasterDatas[rowIndex].MstLocationId,
      pinCode: bindSupplierMasterDatas[rowIndex].SupplierPincode,

      date: supplierDatePart,
      commodities: bindSupplierMasterDatas[rowIndex].SupplierCommodities,
      showImage: bindSupplierMasterDatas[rowIndex].SupplierLogo,
      contactPerson:
        bindSupplierMasterDatas[rowIndex].SupplierContactPersonName,
      contactPersonDesignation:
        bindSupplierMasterDatas[rowIndex].SupplierContactPersonDesignation,
      contactNumber: bindSupplierMasterDatas[rowIndex].SupplierMobileNumber,
      contactPersonEmail: bindSupplierMasterDatas[rowIndex].SupplierEmailId,
    });

    setMstSupplierId(bindSupplierMasterDatas[rowIndex].MstSupplierId);
  };

  const handleSupplier = (rowIndex, flag) => {
    // Setting visibility in popup container

    setpopUpOpen(true);

    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }

    setSupplierData(bindSupplierMasterDatas[rowIndex]);
    const CountryrowData = bindSupplierMasterDatas[rowIndex];
    const CountryInfo = countryBindDD.find(
      (ST) => ST.value === CountryrowData.MstCountryId
    );
    const resultCountry = {
      value: CountryrowData.MstCountryId,
      label: CountryInfo ? CountryInfo.label : "",
    };
    const StaterowData = bindSupplierMasterDatas[rowIndex];
    const StateInfo = stateBindDD.find(
      (ST) => ST.value === StaterowData.MstStateId
    );
    const resultState = {
      value: StaterowData.MstStateId,
      label: StateInfo ? StateInfo.label : "DefaultStateLabel",
    };
    const locationrowData = bindSupplierMasterDatas[rowIndex];
    const LocationInfo = getLocationDatas.find(
      (L) => L.MstLocationId === locationrowData.MstLocationId
    );
    const ResultLocation = {
      value: locationrowData.MstLocationId,
      label: LocationInfo ? LocationInfo.LocationName_en : "DefaultStateLabel",
    };
    const medicinesDrugsData = bindSupplierMasterDatas[rowIndex];
    const medicinesDrugsInfo = bindCommoditiesDD.find(
      (ST) => ST.value === medicinesDrugsData.SupplierCommodities
    );
    const resultmedicinesDrugs = {
      value: medicinesDrugsData.SupplierCommodities,
      label: medicinesDrugsInfo ? medicinesDrugsInfo.label : "",
    };
    var supplierDate = bindSupplierMasterDatas[rowIndex].SupplierDate;
    const supplierDatePart = supplierDate.split("T")[0];

    const Supplierdata2 = [
      resultCountry,
      resultState,
      ResultLocation,
      resultmedicinesDrugs,
      supplierDatePart,
    ];

    setSupplierdata2(Supplierdata2);
  };

  const [branchProjectBindDD, setBranchProjectBindDD] = useState([]);
  const [stateBindDD, setStateBindDD] = useState([]);
  const [countryBindDD, setCountryBindDD] = useState([
    { value: "1", label: "India" },
  ]);
  const createdBy = sessionStorage.getItem("createdBy");
  const validate = (flag) => {
    // Initialize an object to store validation errors for each field
    const errors = {};
  };
  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);

    setIsLoading(true);
    if (flag == 1 || flag == 2) {
      // const supplierIdValidate =
      const isFormError = {
        ...supplierFieldsError,
        supplierNameError:
          supplierFields.supplierName.trim().length > 0
            ? ""
            : "Enter Supplier Name",
        addressError: supplierFields.address.length > 0 ? "" : "Enter Address",
        countryError: supplierFields.country ? "" : "Select Country",
        stateError: supplierFields.state ? "" : "Select State",
        // branchProjectError: supplierFields.branchProject ? "" : "Select City",
        branchProjectError:
          supplierFields.branchProject.length > 0
            ? /^[A-Za-z.' ]+$/.test(supplierFields.branchProject)
              ? ""
              : "Only Alphabet and space allowed"
            : "Enter City",


        pinCodeError: supplierFields.pinCode ? "" : "Enter Pin Code",
        contactPersonError:
          supplierFields.contactPerson.length > 0
            ? /^[A-Za-z ]+$/.test(supplierFields.contactPerson)
              ? ""
              : "Only Alphabet and space allowed"
            : "Enter Contact Person",

        contactNumberError:
          supplierFields.contactNumber.length > 0
            ? /^\d{10,11}$/.test(supplierFields.contactNumber)
              ? ""
              : "Enter a valid Contact Number"
            : "Enter Contact Number",

        contactPersonDesignationError:
          supplierFields.contactPersonDesignation.length > 0
            ? /^[A-Za-z.' ]+$/.test(supplierFields.contactPersonDesignation)
              ? ""
              : "Only Alphabet and space allowed"
            : "Enter Designation",
      };
      setSupplierFieldsError(isFormError);
      const isFormValid = Object.values(isFormError).every(
        (error) => error === ""
      );
      if (isFormValid) {
        setSubmitBtnDisabled(true);
        setIsLoading(true);
        const supplierPayload = [
          {
            mstSupplierId: mstSupplierId ? mstSupplierId : 0,
            supplierName: supplierFields.supplierName,
            supplierId: supplierFields.supplierId,
            mstCountryId: supplierFields.country,
            mstStateId: supplierFields.state,
            mstLocationId: supplierFields.branchProject,
            supplierAddress: supplierFields.address,
            supplierPincode: supplierFields.pinCode,
            supplierLogo: supplierFields.showImage,
            supplierContactPersonName: supplierFields.contactPerson,
            supplierContactPersonDesignation:
              supplierFields.contactPersonDesignation,
            supplierMobileNumber: supplierFields.contactNumber,
            supplierEmailId: supplierFields.contactPersonEmail,
            supplierDate: supplierFields.date,
            supplierCommodities: supplierFields.commodities,
            createdby: createdBy,
            flag: flag,
          },
        ];

        const response = await IUDAPI(
          supplierPayload,
          "SupplierAPI/IUDSupplier"
        );

        if (flag == 1) {
          // Submit

          if (response.data.Table[0].Result === "S") {
            toast.success("Supplier added successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setSubmitVisibleButton(true);
            setIsLoading(true);
            setSupplierFields({
              ...supplierFields,
              supplierId: response.data.Table1[0].SupplierId,
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to add Supplier data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 2) {
          // Update
          if (response.data.Table[0].Result === "M") {
            toast.success("Supplier updated successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to update Supplier data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
        setIsLoading(false);
        setIsOpen(true);
        if (isFormError.supplierNameError && supplierNameRef.current) {
          supplierNameRef.current.focus();
        } else if (isFormError.addressError && addressRef.current) {
          addressRef.current.focus();
        } else if (isFormError.countryError && countryRef.current) {
          countryRef.current.focus();
        } else if (isFormError.stateError && stateRef.current) {
          stateRef.current.focus();
        } else if (isFormError.branchProjectError && branchProjectRef.current) {
          branchProjectRef.current.focus();
        } else if (isFormError.pinCodeError && pinCodeRef.current) {
          pinCodeRef.current.focus();
        } else if (isFormError.contactPersonError && contactPersonRef.current) {
          contactPersonRef.current.focus();
        } else if (
          isFormError.contactPersonDesignationError &&
          contactPersonDesignationRef.current
        ) {
          contactPersonDesignationRef.current.focus();
        } else if (isFormError.contactNumberError && contactNumberRef.current) {
          contactNumberRef.current.focus();
        }
      }
    } else {
      const data = {
        mstSupplierId: bindSupplierMasterDatas[items].MstSupplierId,
        createdBy: createdBy,
        flag: flag,
      };
      const response = await IUDAPI([data], "SupplierAPI/IUDSupplier");
      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success(
            "Supplier data deleted successfully 🗑️",
            5000,
            cancel()
          );
        } else {
          toast.error("Failed to delete Supplier data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success(
            "Supplier data blocked successfully 🚫",
            5000,
            cancel()
          );
          cancel();
        } else {
          toast.error("Failed to block Supplier data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success(
            "Supplier data unblocked successfully ✅",
            5000,
            cancel()
          );
          cancel();
        } else {
          toast.error("Failed to unblock Supplier data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      }
    }
  };
  useEffect(() => {
    if (location.pathname == "/suppliermaster") {
      setAddScreenTitle(false);
      setVisibleTable(true);
      setVisibleAdd(false);
    }
  }, [location]);

  // const handleExport = async () => {
  //   const locationResponse = await BindAPI("SupplierAPI/ExcelExportSupplier");



  //   // ✅ EXPORT WITH LOCAL DATA (IMMEDIATE)
  //   exportData(
  //     supplierMasterExcelExportHeader.map((column) => column.title),
  //     locationResponse.data.Table
  //   );
  // };

  const handleExport = async () => {
    const createdBy = sessionStorage.getItem("createdBy");

    try {
      const locationResponse = await BindAPI(
        "SupplierAPI/ExcelExportSupplier"
      );

      const rows = locationResponse?.data?.Table || [];

      if (rows.length === 0) {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "SUPPLIER MASTER",
            action: "EXCEL EXPORT",
            status: "FAILED",
            tableName: "mst_supplier",
            description: "No data available to export",
          },
          "Log/IUDLog"
        );

        toast.error("No data available to export", {
          duration: 1000,
          position: "top-center",
        });

        return;
      } else {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "SUPPLIER MASTER",
            action: "EXCEL EXPORT",
            status: "SUCCESS",
            tableName: "mst_supplier",
            description: `Supplier Excel exported successfully. Total Records: ${rows.length}`,
          },
          "Log/IUDLog"
        );
      }

      // ✅ EXPORT WITH LOCAL DATA (IMMEDIATE)
      exportData(
        supplierMasterExcelExportHeader.map((column) => column.title),
        rows
      );
    } catch (error) {
      console.error("Excel export error:", error);

      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "SUPPLIER MASTER",
          action: "EXCEL EXPORT",
          status: "FAILED",
          tableName: "mst_supplier",
          description: error?.message || "Excel export failed",
        },
        "Log/IUDLog"
      );

      toast.error("Failed to export Excel", {
        duration: 1500,
        position: "top-center",
      });
    }
  };
  const exportData = (columns, rows, dateRange, selectedDetails) => {
    // Title row configuration
    const titleRow = [
      {
        v: "Supplier Master",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];




    // Add "Row Total" to headers
    const headerRow = [
      ...columns.map((column) => ({
        v: column,
        s: {
          fill: { fgColor: { rgb: "2D2D6E" } },
          font: { bold: true, color: { rgb: "FFFFFF" } },
          alignment: { horizontal: "left" },
        },
      })),

    ];



    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
      const rowStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      return [
        { v: index + 1, s: rowStyle },
        { v: rowData.MstSupplierId, s: rowStyle },
        { v: rowData.SupplierId, s: rowStyle },
        { v: rowData.SupplierName, s: rowStyle },
        { v: rowData.SupplierAddress, s: rowStyle },

        { v: rowData.CountryName_en, s: rowStyle },
        { v: rowData.StateName_en, s: rowStyle },
        { v: rowData.LocationName_en, s: rowStyle },
        { v: rowData.SupplierPincode, s: rowStyle },

        { v: rowData.SupplierDate, s: rowStyle },
        { v: rowData.SupplierLogo, s: rowStyle },
        { v: rowData.SupplierContactPersonName, s: rowStyle },
        { v: rowData.SupplierContactPersonDesignation, s: rowStyle },

        { v: rowData.SupplierMobileNumber, s: rowStyle },
        { v: rowData.SupplierEmailId, s: rowStyle },
        { v: rowData.CreatedBy, s: rowStyle },


      ];
    });



    // Combine all rows
    const wsData = [
      titleRow,
      headerRow,
      ...dataRows,
    ];
    // const wsData = [headerRow, ...dataRows];
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Set custom column widths
    ws["!cols"] = [
      { width: 8 }, // Index
      { width: 20 }, // Branch
      { width: 20 }, // Branch
      { width: 30 }, // Services
      { width: 30 }, // Services
      { width: 30 }, // Services
      { width: 30 }, // Services
      { width: 30 }, // Female Child
      { width: 30 }, // Male Child
      { width: 30 }, // Other Child
      { width: 30 }, // Row Total
      { width: 30 }, // Services
      { width: 30 }, // Female Child
      { width: 30 }, // Male Child
      { width: 30 }, // Other Child
      { width: 30 }, // Row Total
    ];

    ws["!rows"] = [
      { hpt: 30 }, // Title row height
      { hpt: 15 }, // Date range row height
      { hpt: 15 }, // Branch row height (taller for wrapped content)
      { hpt: 15 }, // Spacing row height
      { hpt: 15 }, // Header row height (taller for wrapped content)
      ...Array(rows.length).fill({ hpt: 15 }), // Data rows height
      { hpt: 15 }, // Totals row height
    ];

    // Apply borders and styles
    const applyStyles = (ws) => {
      const range = XLSX.utils.decode_range(ws["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellRef]) continue;

          // Add borders to all cells
          ws[cellRef].s = {
            ...ws[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Supplier Master.xlsx");
  };

  return (
    <MainLayout pageName={"2"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Supplier Master"
          header={supplierMasterHeader}
          records={bindSupplierMasterDatas}
          blockView={true}
          handleEdit={handleEdit}
          handleAction={handleSupplier}
          showAdd={showAdd}

          handleExport={handleExport}
          handleExportBtn={true}
        />
      )}

      {visibleAdd && (
        <div class=" flex flex-col w-full">
          <div class={mainTable.clientMasterMainAdd}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Supplier Master"
            />

            <div class={mainTable.addShadowScreen}>
              <div class={mainTable.mainContentScreen}>
                <form class={mainTable.formForClientMaster}>
                  <div class={mainTable.labelBold}>Supplier Details</div>

                  <hr class={mainTable.horizontalLine}></hr>

                  <div class="grid gap-4 mb-6 md:grid-cols-3">
                    <InputText
                      inputType={"text"}
                      title={" Supplier Id"}
                      name={" supplierId"}
                      maxLength={20}
                      classStar={"text-red-500"}
                      content={supplierFields.supplierId}
                      controlFunc={(e) =>
                        setSupplierFields({
                          ...supplierFields,
                          supplierId: e.target.value,
                        })
                      }
                      disabled={true}
                    />

                    <InputText
                      ref={supplierNameRef}
                      inputType={"text"}
                      title={"Supplier Name"}
                      name={"suppliername"}
                      classStar={"text-red-500"}
                      maxLength={100}
                      content={supplierFields.supplierName}
                      controlFunc={(e) =>
                        setSupplierFields({
                          ...supplierFields,
                          supplierName: e.target.value,
                        })
                      }
                      controlFuncBlur={() => {
                        setSupplierFieldsError((supplierFieldsError) => ({
                          ...supplierFieldsError,
                          supplierNameError:
                            supplierFields.supplierName &&
                              supplierFields.supplierName.trim().length > 0
                              ? ""
                              : "Enter Supplier Name",
                        }));
                      }}
                      errorMessage={supplierFieldsError.supplierNameError}
                    />
                    <InputText
                      ref={addressRef}
                      inputType={"text"}
                      title={"Address"}
                      maxLength={500}
                      name={"address"}
                      classStar={"text-red-500"}
                      content={supplierFields.address}
                      controlFunc={(e) =>
                        setSupplierFields({
                          ...supplierFields,
                          address: e.target.value,
                        })
                      }
                      controlFuncBlur={() => {
                        setSupplierFieldsError((supplierFieldsError) => ({
                          ...supplierFieldsError,
                          addressError:
                            supplierFields.address &&
                              supplierFields.address.length > 0
                              ? /^[A-Za-z0-9, -/]+$/.test(
                                supplierFields.address
                              )
                                ? ""
                                : "Only Alphabets, numbers, commas, hyphens, and spaces allowed"
                              : "Enter Address",
                        }));
                      }}
                      errorMessage={supplierFieldsError.addressError}
                    />
                    <AutoDropDown
                      title="Country"
                      ref={countryRef}
                      options={countryBindDD}
                      placeholder="Select"
                      name="country"
                      selectedOption={countryBindDD.find(
                        (x) => x.value == supplierFields.country
                      )}
                      Class="custom-class"
                      tabIndex="1"
                      classStar="text-red-500"
                      controlFunc={(value, e) => {
                        handleSupplierFieldsChange(value.value, e.name);
                      }}
                      controlFuncBlur={() => {
                        setSupplierFieldsError(() => ({
                          ...supplierFieldsError,
                          countryError: supplierFields.country
                            ? ""
                            : "Select Country",
                        }));
                      }}
                      errorMessage={supplierFieldsError.countryError}
                      setError={setSupplierFieldsError}
                    />
                    <AutoDropDown
                      title="State"
                      ref={stateRef}
                      options={stateBindDD}
                      placeholder="Select"
                      name="state"
                      selectedOption={stateBindDD.find(
                        (x) => x.value == supplierFields.state
                      )}
                      Class="p-0"
                      tabIndex="1"
                      classStar="text-red-500"
                      controlFunc={(value, e) => {
                        handleSupplierFieldsChange(value.value, e.name);
                        setSupplierFields({
                          ...supplierFields,
                          state: value.value,
                          branchProject: "",
                        });
                        setSupplierFieldsError({
                          ...supplierFieldsError,
                          stateError: value ? "" : "Select State",
                        });
                      }}
                      controlFuncBlur={() => {
                        setSupplierFieldsError(() => ({
                          ...supplierFieldsError,
                          stateError: supplierFields.state
                            ? ""
                            : "Select State",
                        }));
                      }}
                      errorMessage={supplierFieldsError.stateError}
                      setError={setSupplierFieldsError}
                    />

                    <InputText
                      ref={branchProjectRef}
                      inputType={"text"}
                      title={"City"}
                      name={"branchProject"}
                      classStar={"text-red-500"}
                      maxLength={100}
                      content={supplierFields.branchProject}
                      controlFunc={(e) =>
                        setSupplierFields({
                          ...supplierFields,
                          branchProject: e.target.value,
                        })
                      }
                      controlFuncBlur={() => {
                        setSupplierFieldsError((supplierFieldsError) => ({
                          ...supplierFieldsError,
                          branchProjectError:
                            supplierFields.supplierbranchProjectName &&
                              supplierFields.branchProject.length > 0
                              ? /^[A-Za-z.' ]+$/.test(
                                supplierFields.branchProject
                              )
                                ? ""
                                : "Only Alphabet and space allowed"
                              : "Enter City",
                        }));
                      }}
                      errorMessage={supplierFieldsError.branchProjectError}
                    />

                    {/* <AutoDropDown
                      title="City"
                      ref={branchProjectRef}
                      options={branchProjectBindDD}
                      placeholder="Select"
                      name="branchProject"
                      selectedOption={
                        supplierFields.branchProject
                          ? branchProjectBindDD.find(
                            (x) => x.value == supplierFields.branchProject
                          )
                          : ""
                      }
                      Class="custom-class"
                      tabIndex="1"
                      classStar="text-red-500"
                      controlFunc={(value, e) => {
                        handleSupplierFieldsChange(value.value, e.name);
                      }}
                      controlFuncBlur={() => {
                        setSupplierFieldsError(() => ({
                          ...supplierFieldsError,
                          branchProjectError: supplierFields.branchProject
                            ? ""
                            : "Select City",
                        }));
                      }}
                      errorMessage={supplierFieldsError.branchProjectError}
                    /> */}

                    <InputText
                      ref={pinCodeRef}
                      inputType={"text"}
                      title={"Pin Code"}
                      name={"pinCode"}
                      classStar={"text-red-500"}
                      maxLength={6}
                      content={supplierFields.pinCode}
                      controlFunc={(e) =>
                        setSupplierFields({
                          ...supplierFields,
                          pinCode: e.target.value,
                        })
                      }
                      controlFuncBlur={() => {
                        setSupplierFieldsError((supplierFieldsError) => ({
                          ...supplierFieldsError,
                          pinCodeError:
                            supplierFields.pinCode &&
                              supplierFields.pinCode.length > 0
                              ? /^[\d\s]+$/.test(supplierFields.pinCode)
                                ? ""
                                : "Only numbers allowed"
                              : "Enter Pin Code",
                        }));
                      }}
                      errorMessage={supplierFieldsError.pinCodeError}
                    />
                    <InputText
                      inputType="date"
                      title="Date"
                      classStar="text-red-500"
                      name="date"
                      content={supplierFields.date}
                      controlFunc={(e) =>
                        setSupplierFields({
                          ...supplierFields,
                          date: e.target.value,
                        })
                      }
                    />
                  </div>
                  <FileUpload
                    title="Logo"
                    apiCall="SupplierAPI/SupplierImageUpload"
                    modalName="SupplierLogo"
                    name="showImage"
                    disabledBtn={updateScreenTitle}
                    showImage={supplierFields.showImage}
                    showImageData={handleShowImage}
                    imageUploadedError={supplierFieldsError.showImageError}
                    limitMassage={
                      "Image size limit: 2MB. Accepted Image types:jpg, png, jpeg."
                    }
                    MAX_FILE_SIZE_MB={2}
                    ALLOWED_FORMATS={["image/jpeg", "image/jpg", "image/png"]}
                  />
                  <div class={mainTable.labelBold}>Contact Info</div>

                  <hr class={mainTable.horizontalLine}></hr>

                  <div class="grid gap-4 mb-6 md:grid-cols-3">
                    <InputText
                      ref={contactPersonRef}
                      inputType={"text"}
                      title={"Contact Person"}
                      name={"contactPerson"}
                      classStar={"text-red-500"}
                      maxLength={100}
                      content={supplierFields.contactPerson}
                      controlFunc={(e) =>
                        setSupplierFields({
                          ...supplierFields,
                          contactPerson: e.target.value,
                        })
                      }
                      controlFuncBlur={(e) => {
                        setSupplierFieldsError((supplierFieldsError) => ({
                          ...supplierFieldsError,
                          contactPersonError:
                            supplierFields.contactPerson &&
                              supplierFields.contactPerson.length > 0
                              ? /^[A-Za-z ]+$/.test(
                                supplierFields.contactPerson
                              )
                                ? ""
                                : "Only Alphabet and space allowed"
                              : "Enter Contact Person",
                        }));
                      }}
                      errorMessage={supplierFieldsError.contactPersonError}
                    />
                    <InputText
                      ref={contactPersonDesignationRef}
                      inputType={"text"}
                      title={"Designation"}
                      name={"contactPersonDesignation"}
                      classStar={"text-red-500"}
                      maxLength={50}
                      content={supplierFields.contactPersonDesignation}
                      controlFunc={(e) =>
                        setSupplierFields({
                          ...supplierFields,
                          contactPersonDesignation: e.target.value,
                        })
                      }
                      controlFuncBlur={(e) => {
                        setSupplierFieldsError((supplierFieldsError) => ({
                          ...supplierFieldsError,
                          contactPersonDesignationError:
                            supplierFields.contactPersonDesignation &&
                              supplierFields.contactPersonDesignation.length > 0
                              ? /^[A-Za-z ]+$/.test(
                                supplierFields.contactPersonDesignation
                              )
                                ? ""
                                : "Only Alphabet and space allowed"
                              : "Enter Designation",
                        }));
                      }}
                      errorMessage={
                        supplierFieldsError.contactPersonDesignationError
                      }
                    />

                    <InputText
                      ref={contactNumberRef}
                      inputType={"text"}
                      title={"Contact Number"}
                      name={"contactNumber"}
                      classStar={"text-red-500"}
                      maxLength={11}
                      content={supplierFields.contactNumber}
                      controlFunc={(e) =>
                        setSupplierFields({
                          ...supplierFields,
                          contactNumber: e.target.value,
                        })
                      }
                      controlFuncBlur={(e) => {
                        setSupplierFieldsError((supplierFieldsError) => ({
                          ...supplierFieldsError,
                          contactNumberError:
                            supplierFields.contactNumber &&
                              supplierFields.contactNumber.length > 0
                              ? /^\d{10,11}$/.test(supplierFields.contactNumber)
                                ? ""
                                : "Enter a valid Contact Number"
                              : "Enter Contact Number",
                        }));
                      }}
                      errorMessage={supplierFieldsError.contactNumberError}
                    />

                    <InputText
                      inputType={"text"}
                      title={"Email"}
                      name={"contactPersonEmail"}
                      content={supplierFields.contactPersonEmail}
                      controlFunc={(e) =>
                        setSupplierFields({
                          ...supplierFields,
                          contactPersonEmail: e.target.value,
                        })
                      }
                    />
                  </div>
                </form>

                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  handleSubmit={handleSubmit}
                  cancel={cancel}
                  disabledBtn={submitBtnDisabled ? true : false}
                />
                {submitVisibleButton && (
                  <div className="border p-2 flex flex-col items-center justify-center ">
                    <label className="flex gap-1  mb-2 text-sm font-medium text-neutral-700 ">
                      Supplier Id :
                      <span className=" mb-2 text-sm font-bold text-neutral-700 ">
                        {supplierFields.supplierId}
                      </span>
                    </label>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={() => setpopUpOpen(true)}
      >
        <div>
          <PopUpScreenTitle
            title="Supplier Master"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />

          <SupplierPopup data={supplierData} data1={supplierdata2} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default SupplierMaster;
